import { render } from "./DashboardShifts.vue?vue&type=template&id=1c6d374c&scoped=true&ts=true"
import script from "./DashboardShifts.vue?vue&type=script&lang=ts"
export * from "./DashboardShifts.vue?vue&type=script&lang=ts"

import "./DashboardShifts.vue?vue&type=style&index=0&id=1c6d374c&scoped=true&lang=scss"

import exportComponent from "/builds/maqqie/maqqie-client-portal/clientportal-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c6d374c"]])

export default __exports__